import React from "react";

import { ReactComponent as Logo } from "../../assets/images/smartocto-logo-light.svg";

const NotFound = () => {
	return (
		<div className="not-found">
			<div className="not-found__content">
				<h2>This page does not exist</h2>
				<p>Please contact the smartocto Waves superuser in your organisation.</p>
				<p className="go-back">Go back to <a href="/admin">administration dashboard</a></p>
				<Logo/>
			</div>
		</div>
	);
};

export default NotFound;
